<avn-progressbar *ngIf="showProgressBar" [showValue]="true" [showIcon]="false" [max]="100" [finished]="percentCompletion === 100">
  <avn-progress-segment [value]="percentCompletion" [avnTheme]="progressBarTheme"></avn-progress-segment>
</avn-progressbar>
